import { Ripple } from "primereact/ripple";
import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Button, ModalFooter } from "reactstrap";
import { t } from "i18next";

const ConfirmDialogDemo = (props) => {
    const [visible, setVisible] = useState<boolean>(props.visible);

    useEffect(() => {
        setVisible(props.visible);
    }, [props.visible]);

    const accept = () => {
        props.handleAccept(true, props.differentiate);
        setVisible(false);
        props.handleClose(false);
    };

    const reject = () => {
        props.handleAccept(false);
        setVisible(false);
        props.handleClose(false);
    };

    return (
        <div className="text-center">
            <Modal isOpen={visible} zIndex={1250}>
                <ModalHeader>{props.header}</ModalHeader>
                <ModalBody>{props.message}</ModalBody>
                <ModalFooter>
                    <Button className="wgbtn p-ripple" onClick={() => accept()}>
                        <Ripple /> {t("Yes")}
                    </Button>{" "}
                    <Button className="wgclear-btn p-ripple" onClick={() => reject()}>
                        <Ripple /> {t("No")}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};
export default ConfirmDialogDemo;
